import React, {useState} from 'react';
import {Autocomplete, Chip, FormHelperText, InputLabel, Stack, TextField} from '@mui/material';

interface MultiDatePickerComponentProps {
  color?: 'primary' | 'secondary';
  error?: string;
  handleChange?: (values: string[]) => void;
  label?: string;
  labelWidth?: number;
  inputWidth?: number;
  placeholder?: string;
  readOnly?: boolean;
  required?: boolean;
  values?: string[];
}

const MultiTextFieldComponent = (props: MultiDatePickerComponentProps) => {
  const {
    color = 'primary',
    error,
    handleChange,
    label,
    labelWidth,
    inputWidth,
    placeholder,
    readOnly,
    required,
    values = [],
  } = props;

  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      multiple
      options={[]}
      value={values}
      freeSolo
      readOnly={readOnly}
      inputValue={inputValue}
      renderTags={(values: string[], getTagProps) =>
        values.map((value: string, index: number) => (
          <Chip
            variant="filled"
            color={color}
            size="small"
            label={value}
            {...getTagProps({index})}
            onClick={() => {
              navigator.clipboard.writeText(value);
            }}
            onDelete={!readOnly
              ? () => handleChange?.(values.filter((_, valueIndex) => valueIndex !== index))
              : undefined
            }/>
        ))
      }
      onInputChange={(evt, newInputValue) => {
        const options = newInputValue.split(',');

        if (options.length > 1) {
          handleChange?.(values.concat(options)
            .map(x => x.trim())
            .filter(x => x));
          setInputValue('');
        } else {
          setInputValue(newInputValue);
        }
      }}
      onChange={(evt, newValues?: string[]) => handleChange?.(newValues ? newValues : [])}
      renderInput={(params) => (
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          {!!label && (
            <InputLabel error={!!error} sx={{width: labelWidth ? `${labelWidth}px` : undefined}}>
              {label + (required ? '*' : '')}
            </InputLabel>
          )}
          <Stack flex={!inputWidth ? 1 : undefined}>
            <TextField
              {...params}
              sx={{flex: 1, width: inputWidth ? `${inputWidth}px` : undefined}}
              color={color}
              focused={readOnly ? false : undefined}
              InputProps={{
                ...params.InputProps,
                endAdornment: null,
              }}
              inputProps={{
                ...params.inputProps,
                placeholder: placeholder,
              }}
            />
            {!!error && (
              <FormHelperText error sx={{mx: '14px', paddingLeft: '20px'}}>{error}</FormHelperText>
            )}
          </Stack>
        </Stack>
      )}/>
  );
};

export default MultiTextFieldComponent;
